/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PaymentType } from './paymentType';

export interface UserPaymentMethod { 
    id?: number;
    denominationId?: number;
    card_number?: string;
    card_hash?: string;
    owner_firstName?: string;
    owner_lastName?: string;
    walletId?: string;
    idAgreementAuth?: string;
    registration_date?: Date;
    expiryMonth?: number;
    expiryYear?: number;
    isValid?: boolean;
    userWalletId?: number;
    paymentTypeId?: number;
    paymentType?: PaymentType;
    broker?: UserPaymentMethod.BrokerEnum;
}
export namespace UserPaymentMethod {
    export type BrokerEnum = 'Mercury' | 'Nexi' | 'Satispay' | 'Stripe';
    export const BrokerEnum = {
        Mercury: 'Mercury' as BrokerEnum,
        Nexi: 'Nexi' as BrokerEnum,
        Satispay: 'Satispay' as BrokerEnum,
        Stripe: 'Stripe' as BrokerEnum
    };
}